export const checkIfMultipleDamageFlow = (gData: any) => {
    return (
        gData?.timeline?.latest_stage_details &&
        gData.timeline.latest_stage_details?.data?.approved_damages?.length &&
        gData.timeline.latest_stage_details?.data?.pending_damages?.length
    );
};

export default {};
